module.exports = requirejs;


//////////////////
// WEBPACK FOOTER
// external "requirejs"
// module id = 15
// module chunks = 0